/** English copy. Keys here are the source of truth for every locale. */
export const en = {
  "doc.title": "Mapus",
  "brand.name": "Mapus",
  "brand.tagline": "Quests on the map",
  "home.seo.intro":
    "Browse quests on the map, open a route to see distance and area, then follow the line in the real world. Creators publish route quests; players match their track to the drawing.",

  "place.add": "Add Point",
  "snapshot.save": "Save",
  "snapshot.open": "Snapshot",
  "snapshot.close": "Close",
  "snapshot.saved": "Saved {count} roads.",
  "snapshot.saved.one": "Saved {count} road.",
  "snapshot.none": "No roads to save in this Area.",

  "account.logout": "Log out",
  "account.hello": "Hello, {name}",
  "account.runner": "Runner",
  "account.trust": "Trust {trust}",
  "account.signedOut": "Signed out.",
  "account.logoutDiscard": "You have unsaved changes. Log out and discard them?",
  "account.signInFailed": "Couldn't sign in.",

  "hint.tap": "Right-click to add a point. On a phone, tap the map.",
  "hint.boundaryOpen": "Tap around the Area, then tap the first point or Done.",
  "hint.boundaryClosed": "Drag the corners, then Fill Roads.",
  "hint.erase": "Drag across a line to erase it. Ctrl+scroll resizes the brush.",
  "hint.workArea": "Drag a rectangle to set the Canvas. Roads inside are read once.",
  "hint.zoomIn": "Zoom in to draw.",
  "hint.zoomRedraw": "Zoom in and draw again.",
  "hint.loading": "Loading…",
  "hint.desktop":
    "Right-click adds a point. Click a point to select it. Click a line to select it. Click a selected point or line to keep just that one, and click it again to clear it. Click empty map to clear the selection. Shift-click adds or removes. Press W to cycle Box, Circle, Lasso, and Off. Box, Circle, and Lasso select by dragging, even when the drag starts on a point or line. A click on a point or line does nothing, and a click on empty map clears the selection. Shift adds and Ctrl removes, and those clicks do not clear. Off clicks points and lines and drags points. Ctrl+scroll resizes the circle. Drag a point to move it. Press A to cycle select all, exclude decorative lines, and clear. When points are hidden, A, Box, Circle, Lasso, clicks, and Erase skip points and only lines can be selected. Press Alt+A to clear the selection. Press G to move the selection. Press J to join selected points. Press M to merge them into one point. When points or lines are selected, Style sets color, size, width, and pattern. Ctrl+C copies the selected point or line style, and Ctrl+V pastes it. Face fills every closed face, and No fill clears every face. Press F to open Fill Region, and press F again to leave it. Press Delete to dissolve a point on two lines into one line, and to delete an endpoint or a junction with its lines. Press X to open the delete menu. In that menu, D dissolves points, K deletes points and their lines, and L deletes lines. Press E for Erase. Ctrl+scroll resizes the erase brush. Press H to show or hide points. Press Tab to open or close the side panels. Set a Canvas so roads are read once. Use Area to fill roads, and Erase to remove a line. Alt-drag pans the map. Alt+Shift-drag turns left and right, and tilts up and down.",

  "badge.closed": "Run closed",
  "title.label": "Title",
  "title.placeholder": "Han River night run",

  "stats.points": "Points",
  "stats.points.one": "Point",
  "stats.distance": "Distance",
  "stats.repeat": "Repeat",
  "stats.eta": "ETA",
  "stats.disconnected": "Not connected · {count} parts",
  "stats.disconnectedNext": "Zoom to the next cut-off part",
  "issues.gaps": "{count} gaps",
  "issues.gaps.one": "{count} gap",
  "issues.overlaps": "{count} overlaps",
  "issues.overlaps.one": "{count} overlap",
  "issues.crossings": "{count} crossings",
  "issues.crossings.one": "{count} crossing",
  "issues.next": "Zoom to the next one",
  "edit.selectSmallerParts": "Select smaller parts",

  "nearby.open": "Nearby",
  "nearby.close": "Close nearby",
  "nearby.title": "Nearby quests",
  "nearby.empty": "No quests around here yet. Move the map to look around.",
  "nearby.failed": "Couldn't load nearby quests.",
  "nearby.meta": "{away} away \u00b7 {length} \u00b7 ~{time}",
  "nearby.metaRoute": "{length} \u00b7 ~{time}",
  "nearby.metaSpots": "{away} away \u00b7 {count} \u00b7 ~{time}",
  "nearby.metaSpotsRoute": "{count} \u00b7 ~{time}",
  "nearby.anonymous": "Anonymous",
  "nearby.busy": "Finish editing before opening a nearby quest.",
  "nearby.emptyCreate": "Know a good walk here? Make the first quest.",
  "nearby.searchArea": "Search this area",
  "quests.mine": "My quests",
  "quests.interest": "Saved quests",
  "quests.interestEmpty": "No saved quests yet. Tap the heart on a quest page to save one.",
  "quests.interestSignIn": "Sign in to see your saved quests.",
  "quests.interestFailed": "Couldn't load saved quests.",
  "quests.signInToSave": "Sign in to save quests.",
  "quest.saveQuest": "Save quest",
  "quest.unsaveQuest": "Remove from saved quests",
  "home.estTime": "Est. time",
  "home.notFound": "That quest isn't available.",
  "home.deleted": "Quest deleted.",
  "home.openQuestPage": "Open quest page: {title}",
  "home.questZoom": "Zoom to quest",
  "home.closeDetail": "Close",
  "home.viewDetails": "View details",

  "sheet.history": "History",
  "sheet.tools": "Tools",
  "sheet.edit": "Edit",
  "sheet.style": "Style",
  "sheet.view": "View",
  "sheet.workArea": "Canvas",
  "sheet.save": "Save",

  "toolbar.undo": "Undo",
  "toolbar.redo": "Redo",
  "toolbar.snap": "Snap",
  "toolbar.crosshair": "Crosshair",
  "toolbar.hidePoints": "Hide Points",
  "toolbar.showPoints": "Show Points",
  "toolbar.deselect": "Deselect",
  "toolbar.selectBox": "Box",
  "toolbar.selectCircle": "Circle",
  "toolbar.selectLasso": "Lasso",
  "toolbar.selectOff": "Off",
  "toolbar.more": "Show or fold the panel",
  "toolbar.details": "Show or fold the details",
  "toolbar.area": "Area",
  "toolbar.done": "Done",
  "toolbar.clearArea": "Clear Area",
  "toolbar.fillRoads": "Fill Roads",
  "toolbar.runFillRoads": "Fill",
  "toolbar.fillColor": "Fill Color",
  "toolbar.erase": "Erase",
  "toolbar.workArea": "Canvas",
  "toolbar.clearWorkArea": "Clear Canvas",

  "eraseSize.label": "Brush size",
  "spacing.label": "Spacing",
  "spacing.meters": "{meters} m",

  "action.save": "Save",
  "action.saving": "Saving…",

  "legend.on": "On road",
  "legend.near": "Near",
  "legend.off": "Off road",

  "menu.deletePoint": "Delete Point",
  "menu.start": "Start",
  "menu.importGpx": "Import GPX",
  "menu.clearAll": "Clear all",
  "menu.settings": "Settings",
  "menu.open": "Menu",
  "menu.clearCache": "Clear cache",

  "settings.title": "Settings",
  "settings.back": "Back",
  "settings.close": "Close",

  "style.title": "Style",
  "style.faces": "Faces",
  "style.apply": "Apply",
  "style.pointColor": "Point color",
  "style.pointSize": "Point size",
  "style.lineColor": "Line color",
  "style.lineWidth": "Line width",
  "style.pattern": "Line pattern",
  "style.solid": "Solid",
  "style.dashed": "Dashed",
  "style.dotted": "Dotted",
  "style.decorative": "Decorative line",
  "style.decorativeMixed": "Mixed decorative",
  "style.mixed": "Mixed",
  "style.px": "px",
  "style.defaults": "Style defaults",
  "style.defaultsHint": "Used for new points and lines.",
  "style.customColor": "Custom color",

  "graphics.title": "Graphics acceleration",
  "theme.title": "Panel theme",
  "theme.white": "White",
  "theme.dark": "Dark",
  "theme.glass": "Glass",
  "account.label": "Account",
  "graphics.statusLabel": "Status",
  "graphics.on": "On",
  "graphics.off": "Off",
  "graphics.unknown": "Unknown",
  "graphics.rendererLabel": "Renderer",
  "graphics.rendererUnknown": "Unavailable",
  "graphics.toast": "Graphics acceleration is off, so the map may draw slowly.",
  "graphics.toastOpen": "Settings",
  "graphics.toastDismiss": "Dismiss",
  "graphics.chromeTitle": "Chrome",
  "graphics.chrome1": "Open chrome://settings/system",
  "graphics.chrome2": "Turn on Use graphics acceleration when available.",
  "graphics.chrome3": "Relaunch Chrome.",
  "graphics.chrome4": "Open chrome://gpu and confirm hardware acceleration is on.",
  "graphics.edge": "Edge: open edge://settings/system, turn on Use graphics acceleration when available, then restart. Check edge://gpu.",
  "graphics.safari": "Safari follows the Mac GPU. Update macOS, and turn off Low Power Mode if the map stays slow.",
  "graphics.firefox": "Firefox: Settings, General, Performance. Leave Use hardware acceleration when available on, then restart.",

  "keymap.title": "Keymap",
  "keymap.preset": "Preset: {name}",
  "keymap.preset.default": "Default",
  "keymap.reset": "Reset to defaults",
  "keymap.capture": "Press a key, scroll, or drag",
  "keymap.conflict": "Already used by {action}.",
  "keymap.mod.alt": "Alt",
  "keymap.mod.shift": "Shift",
  "keymap.mod.ctrl": "Ctrl",
  "keymap.mod.meta": "Cmd",
  "keymap.drag": "Drag",
  "keymap.click": "Click",
  "keymap.wheel": "Scroll",
  "keymap.button.middle": "Middle",
  "keymap.button.right": "Right",
  "keymap.panView": "Pan View",
  "keymap.rotateView": "Rotate View",
  "keymap.placeAtCenter": "Place Point",
  "keymap.selectAll": "Cycle Select All",
  "keymap.deselectAll": "Deselect All",
  "keymap.cycleSelectTool": "Cycle Select Tool",
  "keymap.deleteUnderCursor": "Delete Point Under Cursor",
  "keymap.lassoSelect": "Lasso Select",
  "keymap.lassoAdd": "Lasso Add",
  "keymap.lassoSubtract": "Lasso Subtract",
  "keymap.drawWorkArea": "Draw Canvas",
  "keymap.moveSelected": "Move Selected",
  "keymap.join": "Join",
  "keymap.merge": "Merge",
  "keymap.copyStyle": "Copy Style",
  "keymap.pasteStyle": "Paste Style",
  "keymap.toggleDecorative": "Decorative line",
  "keymap.savePiece": "Save",
  "keymap.exitEdit": "Exit Edit",
  "keymap.enterEdit": "Enter Edit",
  "keymap.fillTool": "Fill Region",
  "keymap.clearRegion": "Clear Fill",
  "keymap.exitFill": "Leave Fill Region",
  "keymap.deleteSelected": "Delete Selected",
  "keymap.deleteMenu": "Delete Menu",
  "keymap.erase": "Erase",
  "keymap.showPoints": "Show Points",
  "keymap.toggleSnap": "Toggle Snap",
  "keymap.fillRoadsTool": "Fill Roads",
  "keymap.cycleRoadsTool": "Cycle Fill Roads Tool",
  "keymap.roadsClear": "Fill Roads: Clear Area",
  "keymap.roadsFill": "Fill Roads: Fill",
  "keymap.roadsBoxFill": "Fill Roads: Box",
  "keymap.roadsCircleStroke": "Fill Roads: Circle Stroke",
  "keymap.resizeRoadsBrush": "Resize Fill Roads Brush",
  "keymap.workArea": "Canvas",
  "keymap.clearWorkArea": "Clear Canvas",
  "keymap.moveCanvas": "Move Canvas",
  "keymap.resizeCanvas": "Resize Canvas",
  "keymap.rotateCanvas": "Rotate Canvas",
  "workPrompt.title": "Set the canvas first",
  "workPrompt.body": "Drag a rectangle on the map to set the drawing canvas.",
  "workPrompt.start": "Set Canvas",
  "workPrompt.later": "Later",
  "keymap.select": "Select",
  "keymap.toggleSelect": "Toggle Select",
  "keymap.zoomMap": "Zoom Map",
  "keymap.resizeEraseBrush": "Resize Erase Brush",
  "keymap.resizeSelectCircle": "Resize Select Circle",
  "keymap.zoomIn": "Zoom In",
  "keymap.zoomOut": "Zoom Out",
  "keymap.zoomInMore": "Zoom In More",
  "keymap.zoomOutMore": "Zoom Out More",
  "keymap.panLeft": "Pan Left",
  "keymap.panRight": "Pan Right",
  "keymap.panUp": "Pan Up",
  "keymap.panDown": "Pan Down",
  "keymap.northUp": "North",
  "keymap.toggleDrawers": "Open/Close Side Panels",
  "keymap.toggleBasemap": "Toggle Satellite",
  "keymap.toggleStreetView": "Street View",
  "keymap.movePoint": "Move Point",
  "keymap.eraseStroke": "Erase Stroke",
  "keymap.moveBoundary": "Move Boundary Corner",
  "keymap.confirmGrab": "Confirm Move",
  "keymap.cancelGrab": "Cancel Move",
  "keymap.confirmDeleteMenu": "Confirm Delete",
  "keymap.cancelDeleteMenu": "Cancel Delete",
  "keymap.deleteMenuNext": "Next Delete Item",
  "keymap.deleteMenuPrev": "Previous Delete Item",
  "keymap.deleteMenuPoints": "Delete Points",
  "keymap.deleteMenuLines": "Delete Lines Only",
  "keymap.deleteMenuPointsAndLines": "Delete Points and Lines",


  "hint.joinFew": "Select at least two points to join.",
  "hint.mergeFew": "Select at least two points to merge.",
  "hint.fillRegion": "Click inside a closed region to fill it. No fill clears that region. Alt-click clears a fill. Click the color chip to change color. Press F or Esc to leave.",
  "hint.fillRegionNone": "No closed region there.",
  "hint.selected": "{count} selected",
  "hint.selectBox": "Box select — drag to select. Click empty map to clear.",
  "hint.selectCircle": "Circle select — paints while dragging. Click empty map to clear.",
  "hint.selectLasso": "Lasso select — drag to select. Click empty map to clear.",
  "hint.selectOff": "Off — click to select",
  "hint.roadsBox": "Box fill — drag a rectangle. Roads inside fill when you release.",
  "hint.roadsCircle": "Circle fill — drag to paint roads. Ctrl+scroll resizes the brush.",

  "move.hint": "Moving {count} points: click or Enter to confirm, Esc or right-click to cancel",
  "move.hint.one": "Moving {count} point: click or Enter to confirm, Esc or right-click to cancel",

  "delete.points": "Delete Points",
  "delete.lines": "Delete Lines Only",
  "delete.pointsAndLines": "Delete Points and Lines",
  "delete.none": "Select points or lines to delete.",

  "trust.label": "Trust",
  "saved.new": "New drawing",
  "saved.trust": "Trust {trust}",
  "saved.loop": "Closed run · ",

  "confirm.clear": "Clear everything you've drawn?",
  "confirm.saveEdit": "You have unsaved changes.",
  "confirm.save": "Save and exit",
  "confirm.discard": "Discard and exit",
  "confirm.cancel": "Cancel",
  "confirm.signIn": "Sign in with Google to save.",
  "confirm.publish":
    "Once published, this drawing can never be edited again. Publish it for everyone?",
  "confirm.publishOk": "Publish",
  "mode.edit": "Edit",
  "mode.exit": "Exit",
  "mode.view": "← View",
  "mode.publish": "Publish",
  "status.private": "Private",
  "status.public": "Public",
  "leave.upload": "Upload & leave",
  "leave.draft": "Draft save",
  "leave.discard": "Discard",
  "style.summary": "Point · Line · Face",
  "pieces.title": "My drawings",
  "pieces.empty": "No drawings yet.",
  "pieces.signedOut": "Sign in to see your saved drawings.",
  "pieces.local": "Not uploaded",
  "pieces.published": "Published",
  "pieces.new": "New",
  "pieces.delete": "Delete",
  "pieces.deleteConfirm": "Delete this drawing?",
  "pieces.deletePublic": "Delete",
  "cache.clear": "Clear cache",
  "cache.cleared": "Cache cleared.",
  "pieces.deletePublicConfirm": "Delete this public drawing for everyone? This cannot be undone.",
  "pieces.deletedPublic": "Public drawing deleted.",
  "toast.draft": "Restored your draft.",
  "toast.draftLeft": "Draft saved. Left edit.",
  "toast.newPiece": "Start a new drawing.",
  "toast.needTitle": "Enter a title.",
  "toast.needLogin": "Sign in with Google to save.",
  "toast.saved": "Saved.",
  "toast.saveFailed": "Couldn't save.",
  "toast.published": "Published.",
  "toast.publishFailed": "Couldn't publish.",
  "toast.locked": "Published quests can't be edited.",
  "toast.gpxRoute": "Imported a GPX route.",
  "toast.gpxTrack": "Imported a GPX track.",
  "toast.loaded": "Loaded {title}",
  "toast.loadFailed": "Couldn't load.",
  "toast.canvasCleared": "Canvas cleared — {undo} to undo",
  "toast.selectAll.all": "All selected",
  "toast.selectAll.excludeDecorative": "Selected excluding decorative lines",
  "toast.selectAll.clear": "Selection cleared",
  "toast.north": "North",
  "toast.northBack": "Back to previous view",
  "toast.northRoute": "Turned to the route's direction",
  "toast.basemapUnavailable": "Satellite map isn't available right now.",
  "toast.geolocationDenied": "Location permission denied. Allow it in your browser settings.",
  "toast.geolocationUnavailable": "Couldn't get your location right now.",

  "gpx.empty": "This GPX file has no track or route.",
  "gpx.failed": "Couldn't read that GPX file.",

  "route.disconnected": "Some lines aren't connected, so this route can't be saved.",
  "route.empty": "Connect at least one line.",

  "fill.closeFirst": "Close the Area first.",
  "fill.tooLarge": "That Area is too large. Draw a smaller one.",
  "fill.fit": "Fit the whole Area on screen, then fill.",
  "fill.zoom": "Roads aren't visible at this zoom. Zoom in and fill again.",
  "fill.tooMany": "Too many points. Widen the spacing or shrink the Area.",
  "fill.empty": "No roads found in this Area.",
  "fill.done": "Filled the roads.",

  "fillRegion.none": "No fill",
  "fillRegion.changeColor": "Change fill color",
  "fillRegion.custom": "Custom",
  "fillRegion.customEmpty": "Empty custom color",
  "fillRegion.customSlot": "Custom color {n}",
  "fillRegion.palette.default": "Default",
  "fillRegion.palette.pastel": "Pastel",
  "fillRegion.palette.vivid": "Vivid",
  "fillRegion.palette.earth": "Earth",
  "fillRegion.palette.mono": "Mono",

  "workArea.outside": "That spot is outside the Canvas.",
  "snap.on": "Snap on",
  "decorativeStroke.on": "Decorative line on for new lines",
  "decorativeStroke.off": "Decorative line off for new lines",
  "snap.off": "Snap off",
  "snap.noPaths": "No paths found in the canvas",
  "workArea.need": "Set a Canvas first.",

  "eta.minutes": "{count} min",
  "eta.minutes.one": "{count} min",
  "eta.hours": "{count} hr",
  "eta.hours.one": "{count} hr",
  "eta.hoursMinutes": "{hours} hr {minutes} min",


  "quests.title": "Quests",
  "quests.create": "New quest",
  "quests.empty": "No quests yet.",
  "quests.draft": "Draft",
  "quests.published": "Published",
  "quests.untitled": "Untitled",
  "quests.noRoute": "No route yet. Use Edit to add one.",
  "quests.loadFailed": "Couldn't load your quests.",
  "quests.signInToCreate": "Sign in to create a quest.",

  "quest.backHome": "Back to map",
  "quest.signInRequired": "Sign in to create a quest.",
  "quest.status.draft": "Draft",
  "quest.status.published": "Published",
  "quest.saveDraft": "Save draft",
  "quest.preview": "Preview",
  "quest.publish": "Publish",
  "quest.edit": "Edit",
  "quest.deleteDraft": "Delete draft",
  "quest.delete": "Delete",
  "quest.cover.placeholder": "Cover image",
  "quest.cover.url": "Paste cover image URL",
  "quest.title.placeholder": "Quest title",
  "quest.tagline.placeholder": "Short tagline",
  "quest.city": "City",
  "quest.country": "Country",
  "quest.tags.placeholder": "Add tag + Enter",
  "quest.by": "By {name}",
  "quest.byUnknown": "By anonymous",
  "quest.summary.distance": "Distance",
  "quest.summary.time": "Time",
  "quest.summary.spots": "Spots",
  "quest.line.none": "No line",
  "quest.line.pickMine": "My drawings",
  "quest.line.pickNearby": "Nearby routes",
  "quest.line.pickPrompt": "Pick a line by number:",
  "quest.line.noneMine": "Publish a quest route first to use it as a line.",
  "quest.line.noneNearby": "No public routes nearby.",
  "quest.map.hint": "Click the map to add a spot. Drag markers to move them.",
  "quest.spots": "Spots",
  "quest.spots.empty": "No spots yet.",
  "quest.spots.emptyEdit": "Click the map to add start and finish spots.",
  "quest.spot.untitled": "Untitled spot",
  "quest.spot.title": "Title",
  "quest.spot.minutes": "Minutes",
  "quest.spot.radius": "Radius (m)",
  "quest.spot.photoRequired": "Photo required",
  "quest.spot.remove": "Remove spot",
  "quest.spot.start": "Start",
  "quest.spot.finish": "Finish",
  "quest.min": "min",
  "quest.slot.stamp": "Stamp",
  "quest.slot.photo": "Photo",
  "quest.unlock.title": "Unlocks on arrival",
  "quest.unlock.story": "Hidden story",
  "quest.unlock.pose": "Pose hint",
  "quest.unlock.link": "Link (YouTube / X / Instagram)",
  "quest.story": "Story",
  "quest.manners": "Manners",
  "quest.text.placeholder": "Write here…",
  "quest.text.empty": "—",
  "quest.more.title": "More",
  "quest.more.placeholder": "More content coming soon",
  "quest.saved": "Draft saved.",
  "quest.saveFailed": "Couldn't save the quest.",
  "quest.publishConfirm": "Published quests can't be edited—only deleted—and are always public. Publish?",
  "quest.published": "Quest published.",
  "quest.publishFailed": "Couldn't publish the quest.",
  "quest.deleteConfirm": "Delete this quest? This can't be undone.",
  "quest.deleteFailed": "Couldn't delete the quest.",

  "quests.new": "New quest",
  "qpick.kicker": "New quest",
  "qpick.title": "What kind of quest?",
  "qpick.sub": "Pick one to start. We will walk you through it step by step.",
  "qpick.spot.title": "Spot Quest",
  "qpick.spot.line": "Visit spots in any order",
  "qpick.spot.detail":
    "Each spot has a title, description, thumbnail, and map location. Add as many as you like.",
  "qpick.route.title": "GPS Art Quest",
  "qpick.route.line": "Follow a route drawn on the map",
  "qpick.route.detail": "You need a title and a drawn route. Start and Finish are added for you.",
  "qpick.start": "Start →",
  "qpick.soon": "Coming soon",
  "qpick.creating": "Setting up your quest…",
  "qbar.newQuest": "New quest",
  "qbar.draftQuest": "Draft quest",
  "qbar.draft": "Draft",
  "qbar.published": "Published",
  "qbar.savedJustNow": "Draft saved just now",
  "qbar.savedAgo": "Draft saved · {count} min ago",
  "qbar.saving": "Saving…",
  "qbar.saveFailed": "Couldn't save the draft",
  "qbar.save": "Save",
  "qbar.autosave": "Auto-save",
  "qbar.saveChanges": "Save changes",
  "qbar.unsaved": "Not saved",
  "qbar.unsavedLive": "Not saved",
  "qbar.liveSaving": "Saving…",
  "qbar.liveSavedJustNow": "Saved",
  "qbar.liveSavedAgo": "Saved · {count} min ago",
  "qbar.liveSaveFailed": "Couldn't save — tap Save to retry",
  "qbar.unsavedLeaveConfirm": "You have unsaved changes. Leave without saving?",
  "qbar.preview": "Preview as player",
  "qbar.exit": "Exit",
  "qpage.label": "Live page — exactly what players will see",
  "rt.kicker": "GPS Art Quest · Follow a route on the map",
  "rt.spot.kicker": "Spot Quest · Places to discover in any order",
  "rt.spot.sub": "Add spots with a title, description, photo, and location—then publish.",
  "rt.spot.heading": "Let's add places to discover",
  "rt.spots": "Spots",
  "rt.spots.desc": "Each spot needs a title, description, thumbnail, and location.",
  "rt.spots.kicker": "Spots",
  "rt.spots.q": "Where should people go?",
  "rt.spots.tapHint": "Tap the map to drop a pin, search for an address, or drag the marker to adjust.",
  "rt.spots.tapToast": "Tap the map to add a spot.",
  "rt.spots.addMap": "+ Add on map",
  "rt.spots.add": "+ Add spot",
  "rt.spots.titlePh": "Spot title",
  "rt.spots.descPh": "What should people know about this spot?",
  "rt.spots.thumb": "Thumbnail",
  "rt.spots.thumbUpload": "Upload photo",
  "rt.spots.thumbReplace": "Replace photo",
  "rt.spots.location": "Location",
  "rt.spots.typeLabel": "Spot",
  "rt.spots.images": "Images",
  "rt.spots.imagesAdd": "Add image",
  "rt.spots.imagesRemove": "Remove",
  "rt.spots.imagesMoveUp": "Move up",
  "rt.spots.imagesMoveDown": "Move down",
  "rt.spots.imageCaptionPh": "Photo caption",
  "rt.spots.thumbCrop.title": "Crop thumbnail",
  "rt.spots.thumbCrop.hint": "Drag to reposition. The thumbnail is a {size}×{size} square used on the map.",
  "rt.spots.locationEdit": "Choose location",
  "rt.spot.location.search": "Search for a place or address",
  "rt.spot.location.set": "Set location",
  "rt.spot.location.coords": "{lat}, {lng}",
  "rt.spot.location.preview": "{address} · {lat}, {lng}",
  "rt.spot.location.noResults": "No places found. Try different words or tap the map.",
  "rt.spot.location.searching": "Searching…",
  "rt.spot.location.searchFailed": "Place search isn't available right now.",
  "rt.spot.lightbox.title": "Spot photo",
  "rt.spot.lightbox.close": "Close",
  "rt.spot.lightbox.prev": "Previous photo",
  "rt.spot.lightbox.next": "Next photo",
  "rt.spot.mapPickHint": "Tap a spot on the map to see its details.",
  "rt.spot.mapClose": "Close spot details",
  "rt.spot.mapPickList": "Spots on this map",
  "rt.spots.delete": "Remove",
  "rt.spots.deleteConfirm": "Delete “{title}”?",
  "rt.heading": "Let's draw your route",
  "rt.headingReady": "Looking good. Anything else?",
  "rt.sub": "Step by step. Only the route, its settings and a title are needed.",
  "rt.subReady": "Every change shows up on the page right away. Add more whenever you like.",
  "rt.required": "Required",
  "rt.editor.selectHint": "Select an item in the list or in the preview to edit it here.",
  "rt.editor.palette": "Add blocks",
  "rt.editor.palettePhoto": "Cover photo",
  "rt.editor.palettePhotoBlock": "Photo",
  "rt.editor.paletteSpot": "Spot",
  "rt.editor.paletteText": "Text",
  "rt.editor.drag": "Drag to reorder",
  "rt.editor.moveUp": "Move up",
  "rt.editor.moveDown": "Move down",
  "rt.spots.locationEmpty": "Location not set",
  "rt.optionalDivider": "Add more if you like",
  "rt.soon": "Coming soon",
  "rt.route": "Route",
  "rt.route.desc": "Draw the path people will walk.",
  "rt.route.add": "+ Add route",
  "rt.route.mapAdded": "Map added — press Edit on the map. The editor opens in a new window.",
  "rt.route.summary": "Route · {distance} · saved from editor",
  "rt.settings": "Route settings",
  "rt.settings.desc": "Start & finish, time limit.",
  "rt.settings.needRoute": "Add a route first, then pick how it's played.",
  "rt.title": "Title & cover",
  "rt.title.desc": "Give it a name people want to walk.",
  "rt.description": "Description",
  "rt.description.desc": "Tell walkers what this quest is about.",
  "rt.mission": "Mission",
  "rt.mission.desc": "Add things to do along the way.",
  "rt.secrets": "Spot secrets",
  "rt.secrets.desc": "Hide a secret at a spot.",
  "rt.story": "Intro story",
  "rt.story.desc": "What's the story here?",
  "rt.manners": "Manners",
  "rt.manners.desc": "Any trail manners to share?",
  "rt.decorate": "Decorate",
  "rt.decorate.desc": "Stick something fun anywhere on the page.",
  "rt.publish": "Publish quest",
  "rt.adminPublished.banner": "This quest is published. Saved changes go live right away.",
  "rt.adminPublished.collapsedLabel": "Quest edit",
  "rt.publishNote": "Auto-translated for players worldwide.",
  "rt.publish.blockedTitle": "Before you can publish",
  "rt.publish.needTitle": "Add a quest title",
  "rt.publish.needRoute": "Draw a route",
  "rt.publish.needSettings": "Finish route settings",
  "rt.publish.needSpots": "Add at least one spot",
  "rt.publish.needSpotFields": "Complete every spot (title, description, photo, and location)",
  "rt.published.heading": "Your quest is live",
  "rt.published.sub": "Published quests can't be edited. You can still delete it.",
  "rt.published.view": "Open the quest page",
  "rt.page.spots": "Spots",
  "rt.page.start": "Start",
  "rt.page.finish": "Finish",
  "rt.page.area": "Quest map",
  "rt.page.placeRegion": "Area",
  "rt.page.story": "The story",
  "rt.page.manners": "Manners",
  "rt.page.photo": "Photo",
  "rt.page.photoCaption": "Caption (optional)",
  "rt.page.photoCaptionPh": "Add a short caption",
  "rt.block.limit": "You can add at most 48 custom blocks.",
  "rt.block.missing": "This block is missing.",
  "rt.block.tip.palette": "Tip",
  "rt.block.tip.title": "Tip",
  "rt.block.tip.label": "Tip text",
  "rt.block.tip.placeholder": "What to bring, best time to visit, parking…",
  "rt.block.quote.palette": "Quote",
  "rt.block.quote.title": "Quote",
  "rt.block.quote.label": "Quote",
  "rt.block.quote.attribution": "Attribution (optional)",
  "rt.block.quote.attributionPh": "Who said it",
  "rt.block.link.palette": "Link",
  "rt.block.link.title": "Link",
  "rt.block.link.url": "URL",
  "rt.block.link.titleField": "Title (optional)",
  "rt.block.link.titlePh": "Link title",
  "rt.block.divider.palette": "Divider",
  "rt.block.divider.title": "Divider",
  "rt.block.divider.note": "A horizontal line on the page. No fields to edit.",
  "rt.block.quiz.palette": "Quiz",
  "rt.block.quiz.title": "Quiz",
  "rt.block.quiz.question": "Question",
  "rt.block.quiz.answer": "Answer",
  "rt.block.quiz.hint": "Hint (optional)",
  "rt.block.quiz.reveal": "Show answer",
  "rt.block.gallery.palette": "Gallery",
  "rt.block.gallery.title": "Gallery",
  "rt.block.gallery.add": "Add photo",
  "rt.block.gallery.remove": "Remove photo",
  "rt.block.gallery.count": "{count} photos",
  "rt.page.edit": "Edit ↗",
  "rt.page.walk": "{time} walk",
  "rt.page.spotCount": "{count} spots",
  "rt.page.spotCount.one": "{count} spot",
  "rt.page.docTitle": "{title} · Mapus",
  "rt.page.docTitleEmpty": "Mapus",
  "rt.explainer.title": "What is a route quest?",
  "rt.explainer.what":
    "A route quest is a path drawn on the map like artwork. Follow that line on real streets and trails by running, walking, or cycling—your GPS track fills in the picture as you go.",
  "rt.explainer.howAnywhereNoLimit":
    "Start anywhere on the route unless this quest sets fixed start and finish points. Follow the line on the ground; your match rate shows how closely you traced it. There is no time limit—go at your own pace.",
  "rt.explainer.howAnywhereLimit":
    "Start anywhere on the route unless this quest sets fixed start and finish points. Follow the line on the ground; your match rate shows how closely you traced it. This quest has a {count}-minute time limit.",
  "rt.explainer.howFixedNoLimit":
    "Start at the marked start and follow the line to the finish. Your match rate shows how closely you traced it. There is no time limit—go at your own pace.",
  "rt.explainer.howFixedLimit":
    "Start at the marked start and follow the line to the finish. Your match rate shows how closely you traced it. This quest has a {count}-minute time limit.",
  "rt.explainer.tips":
    "Stay aware of traffic and follow local laws. Be considerate of residents and private property. You can pause and resume whenever you need to.",
  "rt.summary.placeRoute": "A {distance} route quest around {place}.",
  "rt.summary.titleRoute": "A {distance} route quest: {title}.",
  "rt.summary.walk": "Walking takes about {time}.",
  "rt.summary.endpoints": "It runs from {start} to {finish}.",
  "rt.summary.byAuthor": "Created by {name}.",
  "rt.summary.published": "Published {date}.",
  "rt.map.compassNorth": "Compass: turn north up",
  "rt.map.compassBack": "Compass: back to the previous direction",
  "rt.map.compassRoute": "Compass: turn to the route's direction",
  "rt.map.reset": "Back to start view",
  "rt.map.resetSpots": "Show all spots",
  "rt.map.zoom": "Zoom",
  "rt.map.zoomIn": "Zoom in",
  "rt.map.zoomOut": "Zoom out",
  "rt.map.myLocation": "My location",
  "rt.map.gestureWindows": "Use Ctrl + scroll to zoom the map",
  "rt.map.gestureMac": "Use ⌘ + scroll to zoom the map",
  "rt.map.gestureMobile": "Use two fingers to move the map",
  "rt.map.satellite": "Satellite",
  "rt.map.map": "Map",
  "rt.map.openStreetView": "Open street view",
  "rt.map.openStreetViewInApp": "Street view in app",
  "rt.map.closeStreetView": "Close street view",
  "rt.map.streetViewPanel": "Street view",
  "rt.map.streetViewProviderNaver": "Naver street view",
  "rt.map.streetViewProviderKakao": "Kakao road view",
  "rt.map.streetViewUnavailable": "No street view at this location",
  "rt.map.streetViewCoverage": "Coverage",
  "rt.map.streetViewNoCoverageAtCenter": "No street view at map center",
  "rt.page.by": "By {name}",
  "rt.strip.fixed": "Fixed start & finish",
  "rt.strip.anywhere": "Start anywhere on the route",
  "rt.strip.limit": "{count} min limit",
  "rt.strip.noLimit": "No time limit",
  "rt.step": "Step {n} of {total}",
  "rt.back": "Back",
  "rt.next": "Next",
  "rt.done": "Done",
  "rt.close": "Close",
  "rt.set.kicker1": "Route settings · Start & finish",
  "rt.set.q1": "Where do people start and end?",
  "rt.set.anywhere": "Start anywhere on the route",
  "rt.set.fixed": "Fixed start & finish",
  "rt.set.fixedNote": "Fixed start & finish adds one more step: place them on the line.",
  "rt.set.anywhereNote": "People can join the route wherever they like.",
  "rt.set.kicker2": "Route settings · Place start & finish",
  "rt.set.q2": "Tap the line on the map to place them",
  "rt.set.sub2": "Pins snap to your route and show up on the page right away.",
  "rt.set.placed": "Placed",
  "rt.set.placingStart": "Now tap the line where it starts…",
  "rt.set.placingFinish": "Now tap the line where it ends…",
  "rt.set.placing": "placing",
  "rt.set.tapHint": "Tap the line to place {pin}",
  "rt.set.miss": "Tap closer to the line.",
  "rt.set.kicker3": "Route settings · Time limit",
  "rt.set.q3": "Is there a time limit?",
  "rt.set.noLimit": "No limit",
  "rt.set.limit": "Set a time limit",
  "rt.set.within": "Finish within",
  "rt.set.min": "min",
  "rt.ttl.kicker1": "Title & cover · Title",
  "rt.ttl.q1": "What's your quest called?",
  "rt.ttl.kicker2": "Title & cover · Cover",
  "rt.ttl.q2": "Add a cover photo?",
  "rt.ttl.coverSub": "No photo? The route map is the cover.",
  "rt.ttl.upload": "Upload photo",
  "rt.ttl.skip": "Skip",
  "rt.description.kicker": "Description",
  "rt.description.q": "What is this quest about?",
  "rt.description.placeholder": "A few lines walkers read under the title",
  "rt.story.kicker": "Intro story",
  "rt.story.q": "What's the story here?",
  "rt.manners.kicker": "Manners",
  "rt.manners.q": "Any trail manners to share?",
  "rt.routeSaved": "Route updated from the editor.",
  "rt.signIn": "Sign in to make a quest.",
  "qroute.title": "Edit route",
  "qroute.docTitle": "Edit route · {title} · Mapus",
  "qroute.docTitleUntitled": "Edit route · Mapus",
  "qroute.banner": "For “{title}”. Save sends the route to your quest page.",
  "qroute.bannerUntitled": "Save sends the route to your quest page.",
  "qroute.done": "Done",
  "qroute.keymapSave": "Save Route",
  "qroute.keymapDone": "Done",
  "qroute.sent": "Route sent to your quest. You can close this tab.",
  "qroute.failed": "Couldn't send the route to the quest.",
  "qroute.defaultName": "Quest route",
  "qroute.locked": "This quest is published, so its route can't change.",
  "qroute.workPrompt": "Drag a rectangle on the map to set the route's canvas.",
  "qroute.disconnected": "Some lines aren't connected, so this route can't be saved.",
  "qroute.statsDisconnected": "Not connected · {count} parts",
  "qroute.selectSmallerParts": "Select smaller parts",
  "qroute.cacheCleared": "Map cache cleared.",
  "qroute.signIn": "Sign in to edit this quest's route.",
  "qroute.signInSave": "Sign in with Google to save the route.",
  "qroute.notOwner": "Only the quest's author can edit its route.",
  "qroute.openQuest": "Open quest page",
  "qroute.loading": "Opening the route…",
  "toast.publishMoved": "Publishing drawings is closed. Make a quest instead: New quest → GPS Art Quest.",
  "lang.label": "Language",
  "lang.saveFirst": "Save or exit editing first, then switch the language.",
  "lang.saveFailed": "Couldn't save, so the language didn't change.",
  "api.failed": "Request failed ({status})",
  "cover.add": "Add a cover photo",
  "cover.addSub": "Click or drop an image",
  "cover.replace": "Replace",
  "cover.remove": "Remove",
  "cover.removeConfirm": "Remove this cover?",
  "cover.removed": "Cover removed.",
  "cover.saved": "Cover saved.",
  "cover.uploading": "Uploading…",
  "cover.notice": "Only upload photos you took or have the right to use. Avoid close-ups of people's faces without consent.",
  "cover.err.type": "Pick an image file.",
  "cover.err.size": "That photo is over 15 MB.",
  "cover.err.read": "Couldn't open that photo. Try a JPEG or PNG.",
  "cover.mapAlt": "Route map",
  "cover.crop.title": "Position your cover",
  "cover.crop.hint": "Drag to move. Zoom to fit.",
  "cover.crop.zoom": "Zoom",
  "cover.crop.cancel": "Cancel",
  "cover.crop.use": "Use photo",
  "cover.adminRemove": "Remove cover",
  "report.button": "Report",
  "report.title": "Report this quest",
  "report.reason.spam": "Spam",
  "report.reason.unsafe": "Unsafe",
  "report.reason.copyright": "Copyright infringement",
  "report.reason.other": "Other",
  "report.cancel": "Cancel",
  "report.sent": "Thanks. We'll take a look.",
  "cover.titlePlaceholder": "Quest title",
  "done.title": "Completed by",
  "done.empty": "Be the first to complete this quest",
  "done.more": "Show more",
  "done.anon": "Walker",
  "done.hint": "Finish this quest and leave a line here",
  "done.write": "Leave a line",
  "done.post": "Post",
  "done.save": "Save",
  "done.cancel": "Cancel",
  "done.edit": "Edit",
  "done.delete": "Delete",
  "done.report": "Report",
  "done.remove": "Remove",
  "done.removed": "Line removed.",
  "done.err.empty": "Write a line first.",
  "done.err.long": "Keep it to one short line ({max} characters).",
  "done.err.link": "Links aren't allowed in a line.",
  "ads.label": "Ad",
  "ads.previewLabel": "Ad slot · Preview",
  "ads.previewProposed": "Proposed",
  "privacy.title": "Privacy policy",
  "privacy.link": "Privacy policy",
  "legal.aria": "Legal and contact",
  "legal.about": "About",
  "legal.privacy": "Privacy",
  "legal.terms": "Terms",
  "legal.contact": "Contact",
  "privacy.adsense.title": "Advertising",
  "privacy.adsense.body":
    "When ads are turned on, Google AdSense may show ads on quest pages and the home detail panel. Google and its partners may use cookies or similar technologies to serve ads, including personalized ads where allowed. See Google's partner sites and privacy policy at https://policies.google.com/technologies/ads. For the European Economic Area and United Kingdom, Google requires a certified consent management platform (Funding Choices) in your AdSense account before personalized ads can run.",
} as const;

export type MessageKey = keyof typeof en;
export type Catalog = { [K in MessageKey]: string };
